var OS;
(function (OS) {
  OS["windows"] = "1";
  OS["mac"] = "2";
  OS["linux"] = "3";
  OS["other"] = "4";
})(OS || (OS = {}));
function detectOS() {
  if (typeof window === 'undefined') {
    return OS.other;
  }
  var userAgent = window.navigator.userAgent;
  if (typeof userAgent !== 'string') {
    return OS.other;
  }
  if (userAgent.includes('Windows')) {
    return OS.windows;
  }
  if (userAgent.includes('Mac')) {
    return OS.mac;
  }
  if (userAgent.includes('X11') || userAgent.includes('Linux')) {
    return OS.linux;
  }
  return OS.other;
}

export { detectOS };
